export default "__VITE_ASSET__HAds3qht__"